module.exports = __webpack_public_path__ + "img/jifenduihuan_entrance.ce8cfa8e.jpeg";